import create from "zustand";
import { devtools, persist } from "zustand/middleware";
import * as constant from "../../utils/constant";
import { getLocalStorage } from "../../services/storage";

const userStore = create(
  devtools(
    persist(
      (set) => ({
        auth: {
          isAuthenticated: !!getLocalStorage(constant.STORAGE_TOKEN_KEY),
          token: getLocalStorage(constant.STORAGE_TOKEN_KEY),
          profile: getLocalStorage(constant.STORAGE_PROFILE_KEY),
          commonServiceToken: null,
        },
        setAuth: (auth) => set({ auth }),
      }),
      {
        name: "client-data",
        partialize: (state) => ({ auth: state.auth }),
      }
    )
  )
);

export default userStore;
